import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const SearchBox = ({ onSearch }) => {
  const [term, setTerm] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const query = term.trim();
    if (!query) return;
    navigate(`/search?q=${encodeURIComponent(query)}`);
    if (onSearch) onSearch();
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex items-center border rounded-2xl h-[44px] w-full overflow-hidden"
    >
      <input
        type="text"
        value={term}
        onChange={(e) => setTerm(e.target.value)}
        placeholder="Search all items"
        className="w-full h-full px-4 focus:outline-none"
      />
      <button
        type="submit"
        className="shrink-0 h-full text-white bg-[#DF5645] px-4 hover:bg-[#c03a29] focus:outline-none text-[15px]"
      >
        Search
      </button>
    </form>
  );
};

export default SearchBox;
